/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'hero-2': {
    width: 59,
    height: 59,
    viewBox: '0 0 59 59',
    data: `<path pid="0" _fill="none" _stroke="#FFF" stroke-opacity=".3" d="M1 1c31.48 0 57 25.52 57 57H28.517c0-15.197-12.32-27.517-27.517-27.517V1z"/>`
  }
})
